<div class="content-title-container" *ngIf="title">
  <p class="content-title">{{ title }}</p>
</div>
<div
  class="padded fill-space"
  [class.no-title-padding]="!title"
  [class.no-padding]="noPadding"
>
  <div class="fill-space">
    <ng-content></ng-content>
  </div>
</div>
